module.exports = __webpack_public_path__ + "img/isnet2025.60cbbf06.png";